module.exports = __webpack_public_path__ + "img/afaf48f.png";